import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { AppService } from '../../../../../services';
import { StaffEngagementCountsWidget, StaffEngagementRow } from '../../../../../ui/widget/shared-tab-counts-table/staff-engagement-counts/staff-engagement-counts.widget';
import { VolunteeringAreaService } from '../../../volunteering-area.service';

@Component({
	selector: 'volunteering-prospects-tab-1-part',
	standalone: true,
	imports: [StaffEngagementCountsWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-prospects-tab-1.part.html',
})

export class VolunteeringProspectsTab1Part {

	private areaService = inject(VolunteeringAreaService);
	private app = inject(AppService);

	public staffEngagementData = computed(() => {
		const data = this.areaService.volunteeringData();
		if (!data) return [];

		const prospects = data.volunteerProspects;

		// Group by staff
		const staffMap = new Map<number, { engagedCount: number; assignedCount: number }>();

		prospects.forEach(prospect => {
			// Count engaged (lastContactStaffId)
			if (prospect.lastContactStaffId) {
				const engagedData = staffMap.get(prospect.lastContactStaffId) || { engagedCount: 0, assignedCount: 0 };
				engagedData.engagedCount++;
				staffMap.set(prospect.lastContactStaffId, engagedData);
			}

			// Count assigned (assignedToStaffId)
			if (prospect.assignedToStaffId) {
				const assignedData = staffMap.get(prospect.assignedToStaffId) || { engagedCount: 0, assignedCount: 0 };
				assignedData.assignedCount++;
				staffMap.set(prospect.assignedToStaffId, assignedData);
			}
		});

		// Convert to array format
		const staffEngagementRows: StaffEngagementRow[] = [];
		staffMap.forEach((counts, staffId) => {
			const staffName = this.app.getStaffNameById(staffId) || 'Unknown Staff';
			staffEngagementRows.push({
				staffId,
				staffName,
				engagedCount: counts.engagedCount,
				assignedCount: counts.assignedCount
			});
		});

		// Sort by staff name
		return staffEngagementRows.sort((a, b) => a.staffName.localeCompare(b.staffName));
	});

}
